import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {ff, utils, form, authActions} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Button, Card, CardBody, CardHeader, Col, Row} from "reactstrap";
const {Form, FormActions, FormBody} = form;
import {formValueSelector, reduxForm, SubmissionError} from "redux-form";
import {
    isEmailNotificationsEnabled,
    redirectToOrderStep,
    isSmsNotificationsEnabled,
    getVychoziAdresa
} from "../utils/utils";
import * as steps from "../const/routes";
import NahraneSouboryPanel from "../components/NahraneSouboryPanel";
import ObjectSelect from "../components/ObjectSelect";
import SubjektApi from "../api/gen/cgo/SubjektApi";
import CustomCheckboxField from "../components/CustomCheckboxField";
import * as objednavkaActions from "../actions/objednavkaActions";
import * as subjektActions from "../actions/subjektActions";
import * as opravneniActions from "../actions/opravneniActions";
import NakladoveStrediskoField from "./fields/NakladoveStrediskoField";
import CiselnikApi from "../api/gen/cgo/CiselnikApi";
import './ZakaznikForm.scss';
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář procesu objednávky - Zákazník.
 *
 * Formulář pracuje ve dvou "režimech" - zákazník a operátor.
 * Pokud se jedná o zákazníka, veškerá data přijdou v initialValues od nadřazené stránky.
 * Pokud se jedná o operátora, data si načítá formulář interaktivně na základě uživatele vybraného ve fieldu.
 */
class ZakaznikForm extends Component<WithTranslation> {

    static formName = 'ZakaznikForm';

    static propTypes = {
        kartyList: PropTypes.array, // karty společnosti a přihlášeného uživatele - jen pro režim zákazník
        nakladovaStrediskaList: PropTypes.array, // názvy objednávek společnosti přihlášeného uživatele - jen pro režim zákazník
        zakazkaData: PropTypes.object.isRequired, // data předchozího kroku - zakázky
        isOperator: PropTypes.bool, // zda má být formulář v režimu pro operátora, implicitně false
        spolecnostDetailData: PropTypes.object, // data aktivní společnosti přihlášeného uživatele
    };

    static defaultProps = {
        isOperator: false,
    };

    static getSpolecnostPrevolby = (props) => {
        const {isOperator, spolecnostPredvolby, spolecnostDetailData} = props;
        return isOperator ? (spolecnostPredvolby ? spolecnostPredvolby.data : spolecnostDetailData) : spolecnostDetailData;
    }

    static validate = (values, props) => {
        const {t} = props;
        const usedSpolecnostPredvolby = ZakaznikForm.getSpolecnostPrevolby(props);

        const errors = {};
        if (props.isOperator && !values.uzivatelASpolecnost) {
            errors.uzivatelASpolecnost = t('validation.customer_required');
        }
        if (usedSpolecnostPredvolby && usedSpolecnostPredvolby.povinneNaklStredisko && !values.naklStredObjednavka) {
            errors.naklStredObjednavka = t('validation.order_name_required');
        }

        return errors;
    };

    static customSubmit = (values, _, props) => {
        // Nepřišel jsem na to proč najednou přestala fungovat při submitu automatická validace na naklStredObjednavka
        const usedSpolecnostPredvolby = ZakaznikForm.getSpolecnostPrevolby(props);

        if (usedSpolecnostPredvolby && usedSpolecnostPredvolby.povinneNaklStredisko && !values.naklStredObjednavka) {
            throw new SubmissionError({
                naklStredObjednavka: props.t('validation.order_name_required'),
            });
        }
    }

    componentDidUpdate(prevProps) {
        const prevKartyList = prevProps.uzivatelKartyList;
        const newKartyList = this.props.uzivatelKartyList;
        // Pokud se změnil seznam karet, předvybereme první z nich
        if (prevKartyList !== newKartyList && newKartyList.rows.length > 0) {
            this.fillKarta(newKartyList.rows[0]);
        }
    };

    // Naplnění formuláře daty vybraného uživatele
    fillUzivatel = (uzivatelASpolecnost) => {
        if (uzivatelASpolecnost) {
            this.props.change('jmenoAPrijmeni', uzivatelASpolecnost.zobrazJmeno);
            this.props.change('email', uzivatelASpolecnost.email);
            this.props.change('notifikaceEmail', uzivatelASpolecnost.notifikaceEmail);
            this.props.change('telefon', uzivatelASpolecnost.telefon);
            this.props.change('notifikaceSms', uzivatelASpolecnost.notifikaceSms);

            if (uzivatelASpolecnost.spolecnostId) {
                this.props.change('naSpolecnost', true);
                this.props.change('nazevSpolecnost', uzivatelASpolecnost.nazevSpolecnost);
                this.props.change('ic', uzivatelASpolecnost.ic);
                this.props.change('dic', uzivatelASpolecnost.dic);
            } else {
                this.props.change('naSpolecnost', false);
                this.props.change('nazevSpolecnost', '');
                this.props.change('ic', '');
                this.props.change('dic', '');
            }
        } else {
            this.props.change('naSpolecnost', false);
            this.props.change('nazevSpolecnost', '');
            this.props.change('ic', '');
            this.props.change('dic', '');
            this.props.change('jmenoAPrijmeni', '');
            this.props.change('notifikaceEmail', false);
            this.props.change('notifikaceSms', false);
            this.props.change('email', '');
            this.props.change('telefon', '');
        }
    };

    fillAdresa = (adresa) => {
        if (adresa) {
            this.props.change('ulice', adresa.ulice);
            this.props.change('obec', adresa.obec);
            this.props.change('psc', adresa.psc);
            this.props.change('stat', adresa.stat);
        } else {
            this.props.change('ulice', '');
            this.props.change('obec', '');
            this.props.change('psc', '');
            this.props.change('stat', '');
        }
    };

    fillKarta = (karta) => {
        this.props.change('karta', karta);
    };

    clearAll = () => {
        this.props.change('naSpolecnost', false);
        this.fillUzivatel(null);
        this.fillAdresa(null);
        this.fillKarta(null);
    };

    /**
     * Vrací promise, který vrátí adresy uživatele a karty uživatele a společnosti (pokud je předáno ID společnosti)
     * @param uzivatelId ID uživatele
     * @param spolecnostId ID společnosti, nepovinné
     * @returns {Promise<any>}
     */
    fetchUzivatelASpolecnostDetail = (uzivatelId, spolecnostId) => {
        return new Promise(resolve => {
            const promises = [];
            promises.push(SubjektApi.getAdresyUzivatel(uzivatelId, spolecnostId, false));
            promises.push(SubjektApi.getKartyUzivatel(uzivatelId, false));
            if (spolecnostId) {
                promises.push(SubjektApi.getKartySpolecnost(spolecnostId, false));
                promises.push(CiselnikApi.getNaklStred(spolecnostId));
                promises.push(SubjektApi.getSpolecnostPredvolby(spolecnostId));
            }
            Promise.all(promises).then(values => {
                resolve(values);
            });
        });
    };

    /**
     * Provede načtení adres uživatele a případně společnosti (pokud je vyplněna) a vyplní potřebná pole.
     * @param uzivatelASpolecnost
     */
    handleUzivatelChange = (uzivatelASpolecnost) => {
        const uzivatelId = uzivatelASpolecnost && uzivatelASpolecnost.uzivatelId;
        const spolecnostId = uzivatelASpolecnost && uzivatelASpolecnost.spolecnostId;

        if (!uzivatelId) {
            return this.clearAll();
        }

        this.fillAdresa(null);
        this.fillUzivatel(uzivatelASpolecnost);

        this.props.dispatch(objednavkaActions.invalidateObjednavkaUzivatelKarty());
        this.props.dispatch(objednavkaActions.invalidateObjednavkaSpolecnostNakladovaStrediska());
        this.props.dispatch(objednavkaActions.invalidateObjednavkaSpolecnostPredvolby(spolecnostId));

        this.fetchUzivatelASpolecnostDetail(uzivatelId, spolecnostId).then((result) => {
            const adresyUzivatele = result[0];
            const kartyUzivatele = result[1];
            const kartySpolecnosti = result[2];
            const nakladovaStrediska = result[3];
            const predvolbySpolecnosti = result[4];

            const adresa = getVychoziAdresa(adresyUzivatele);
            this.fillAdresa(adresa);

            // Výběr karty, přednost mají přímo přiřazené uživateli, pak další bez vazby na uživatele
            let kartyList = [];
            if (kartyUzivatele) {
                kartyList = [...kartyUzivatele];
            }
            if (Array.isArray(kartySpolecnosti) && kartySpolecnosti.length > 0) {
                const filtered = kartySpolecnosti.filter(k => !k.uzivatel);
                kartyList = [...kartyList, ...filtered];
            }

            this.props.dispatch(objednavkaActions.setObjednavkaUzivatelKarty(kartyList));
            this.props.dispatch(objednavkaActions.setObjednavkaSpolecnostNakladovaStrediska(spolecnostId, nakladovaStrediska));
            this.props.dispatch(objednavkaActions.setObjednavkaSpolecnostPredvolby(spolecnostId, predvolbySpolecnosti));
        });
    };

    render() {
        const {
            onClose, handleSubmit, naSpolecnost, zakazkaData, isOperator, submitting, uzivatelASpolecnost,
            telefon, email, nakladovaStrediskaList, spolecnostNakladovaStrediskaList, uzivatelKartyList, kartyList,
            authInfo, t
        } = this.props;

        const fileMetas = zakazkaData && zakazkaData.fileMetas || [];
        const disableCheckboxes = submitting || (isOperator && !uzivatelASpolecnost);
        const disableNotifikaceTelefon = disableCheckboxes || !telefon;
        const disableNotifikaceEmail = disableCheckboxes || !email;
        const usedNakladovaStrediska = isOperator ? spolecnostNakladovaStrediskaList.rows ? spolecnostNakladovaStrediskaList.rows : [] : nakladovaStrediskaList;
        const usedSpolecnostPredvolby = ZakaznikForm.getSpolecnostPrevolby(this.props);
        const usedKarty = isOperator ? uzivatelKartyList.rows : kartyList;

        const emailNotificationsEnabled = isEmailNotificationsEnabled(authInfo);
        const smsNotificationsEnabled = isSmsNotificationsEnabled(authInfo);

        const firmaFields = <div>
            <ff.String label={t('admin.company_name')} name="nazevSpolecnost" disabled />
            <ff.Number int label={t('cin')} name="ic" disabled />
            <ff.String label={t('vatin')} name="dic" disabled />
        </div>;
        return <Form onSubmit={handleSubmit(ZakaznikForm.customSubmit)} horizontal className={"zakaznik-form"}>
            <FormBody>
                <Row>
                    <Col xs={12} md={8}>
                        <Card>
                            <CardHeader>
                                <h2>{t('contact_and_billing_information')}</h2>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs={12} md={6}>
                                        {isOperator && <ff.ApiObjectSuggest
                                            className={"mb-3"}
                                            label={false}
                                            name="uzivatelASpolecnost"
                                            filterSuggestions={SubjektApi.getUzivateleASpolecnosti}
                                            placeholder={t('search_for_user')}
                                            dropdown={false}
                                            removable={false}
                                            renderSuggestion={(item) => item ? `${item.zobrazJmeno}${item.nazevSpolecnost ? ", " + item.nazevSpolecnost : ""}` : ""}
                                            getItemValue={(item) => item ? `${item.zobrazJmeno}${item.nazevSpolecnost ? ", " + item.nazevSpolecnost : ""}` : ""}
                                            onChange={this.handleUzivatelChange}
                                        />}
                                        {naSpolecnost && firmaFields}
                                        {naSpolecnost && <ObjectSelect
                                            label={t('card')}
                                            name="karta"
                                            items={usedKarty}
                                            itemValueAttrName="cisloKarta"
                                            showEmpty={true}
                                            disabled={submitting}
                                        />}
                                        <ff.String label={t('firstname_and_surname')} name="jmenoAPrijmeni" disabled />
                                        <ff.String label={t('email')} name="email" disabled />
                                        {emailNotificationsEnabled && <CustomCheckboxField
                                            label={t('order.send_notification_email')}
                                            name="notifikaceEmail"
                                            disabled={disableNotifikaceEmail}
                                            title={disableNotifikaceEmail ? t('validation.email_required') : null}
                                        />}
                                        <ff.String label={t('phone')} name="telefon" disabled />
                                        {smsNotificationsEnabled && <CustomCheckboxField
                                            label={t('order.send_notification_sms')}
                                            name="notifikaceSms"
                                            disabled={disableNotifikaceTelefon}
                                            title={disableNotifikaceTelefon ? t('validation.phone_required') : null}
                                        />}
                                        <ff.String label={t('street_and_house_number')} name="ulice" disabled />
                                        <ff.String label={t('city')} name="obec" disabled />
                                        <ff.String label={t('zip')} name="psc" disabled />
                                        <ff.String label={t('state')} name="stat" disabled />
                                        <hr />
                                        {usedSpolecnostPredvolby && usedSpolecnostPredvolby.naklStrediskoTextem ?
                                            <ff.Base label={t('order.name')}
                                                     name="naklStredObjednavka"
                                                     componentClass={NakladoveStrediskoField}
                                                     nakladovaStrediska={usedNakladovaStrediska}
                                                     required={usedSpolecnostPredvolby && usedSpolecnostPredvolby.povinneNaklStredisko}
                                                     disabled={submitting}
                                            /> : <ff.Autocomplete
                                                label={t('order.name')}
                                                name="naklStredObjednavka"
                                                items={usedNakladovaStrediska}
                                                required={usedSpolecnostPredvolby && usedSpolecnostPredvolby.povinneNaklStredisko}
                                                getItemName={item => item ? item.nazevStredisko : ""}
                                                renderItemContent={(item, name) => name}
                                                disabled={submitting || usedNakladovaStrediska.length === 0}
                                            />
                                        }
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col xs={12} md={4}>
                        <NahraneSouboryPanel soubory={fileMetas.map(meta => meta.podslozky + meta.name)} />
                    </Col>
                    <Col xs={12} className="submit-button-panel">
                        <Button color="secondary" type="button" onClick={redirectToOrderStep.bind(this, steps.ZAKAZKA, this.props)}>{t('buttons.back')}</Button>
                        <Button color="primary">{t('order.next_step')}</Button>
                    </Col>
                </Row>
            </FormBody>
            <FormActions onClose={onClose} disabled />
        </Form>
    }
}

const selector = formValueSelector(ZakaznikForm.formName);

const mapStateToProps = state => ({
    naSpolecnost: selector(state, "naSpolecnost"),
    uzivatelASpolecnost: selector(state, "uzivatelASpolecnost"),
    telefon: selector(state, "telefon"),
    email: selector(state, "email"),
    authInfo: utils.storeFromArea(state, authActions.AUTH_INFO_AREA),
    loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
    objednavkaUzivatelDetail: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKA_UZIVATEL_AREA),
    uzivatelAdresyList: utils.storeFromArea(state, subjektActions.UZIVATEL_AKTIVNI_ADRESY_LIST_AREA),
    objednavkaSpolecnostDetail: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKA_SPOLECNOST_AREA),
    uzivatelKartyList: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKA_UZIVATEL_KARTY_AREA),
    spolecnostKartyList: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKA_SPOLECNOST_KARTY_AREA),
    spolecnostNakladovaStrediskaList: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKA_SPOLECNOST_NAKLSTRED_AREA),
    spolecnostPredvolby: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKA_SPOLECNOST_PREDVOLBY_AREA),
});

export default withTranslation()(withRouter(connect(mapStateToProps)(reduxForm({
    form: ZakaznikForm.formName,
    validate: ZakaznikForm.validate,
})(ZakaznikForm))));
